import ShippingMethod from "./ShippingMethod"

export default ShippingMethod
